// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  z-index: 11;
  background: var(--sebrae-light-gray);
  box-shadow: 0 8px 8px 0 rgba(20, 46, 82, 0.2);
}
header .container {
  height: 100%;
  max-width: 1376px !important;
}
header .hamburger,
header .close {
  border: none;
  background: transparent;
  padding: 0;
}
header .desktop {
  display: none;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}
header .desktop .company {
  flex: 1 1;
  padding: 0;
  padding-left: 8px;
}
header .desktop .company h3 {
  text-transform: uppercase;
}
header .desktop .company button {
  font-size: 12px;
}
header .desktop nav {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: 12px;
}
header .desktop nav:after {
  content: "";
  position: absolute;
  right: 0;
  width: 1px;
  height: 24px;
  background: var(--sebrae-blue-6);
}
header .desktop ul {
  display: flex;
  height: 100%;
}
header .desktop ul li {
  font-size: 13px;
  font-weight: 400;
  color: var(--sebrae-blue-6);
  padding: 5px 8px 0;
  height: 100%;
  border-bottom: 6px solid transparent;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
header .desktop ul li a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font: inherit;
  color: inherit;
  text-decoration: none;
}
header .desktop ul li.active {
  border-color: var(--sebrae-blue-6);
  font-weight: 700;
}
header .desktop .BaSe--User-Apps .BaSe--icon-button {
  font-size: 16px;
}
header .desktop .BaSe--User-Apps .BaSe--icon-button img {
  width: 16px;
  height: 16px;
}
header .desktop .BaSe--User-Apps-menu {
  top: 25px;
  left: auto;
  right: -20px;
}
header .desktop .BaSe--User-Apps-menu div:first-of-type {
  left: auto;
  right: 22px;
}
header .company {
  width: 100%;
  padding: 15px 16px 8px;
  color: var(--sebrae-blue-6);
}
header .company h3 {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
}
header .company button {
  font-size: 11px;
}
header .logo {
  display: inline-block;
  width: 125px;
}
header .btn-white-outline {
  border: none;
}
header .btn-white-outline span {
  font-weight: 400;
}
header .acronyms {
  min-width: 32px;
  width: 32px;
  height: 32px;
}
header .header-actions {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
header .side-menu {
  position: fixed;
  width: 100%;
  height: 100dvh;
  top: 0;
  left: 0;
  z-index: 10;
}
header .side-menu .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.3);
  z-index: -1;
}
header .side-menu nav {
  position: relative;
  z-index: 1;
  width: calc(100% - 56px);
  height: 100%;
  background: var(--sebrae-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}
header .side-menu nav.slide-in {
  animation: slideInLeftToRight 255ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
header .side-menu nav.slide-out {
  animation: slideOutRightToLeft 255ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
header .side-menu nav .nav-actions {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 5px 16px;
}
header .side-menu nav .nav-actions .logo {
  width: 209px;
}
header .side-menu nav .nav-actions .logo img {
  width: 100%;
}
header .side-menu .wrapper-items-mobile {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 56px 1fr;
}
header .side-menu .wrapper-items-mobile .aside-icon {
  background: var(--sebrae-blue-6);
  padding: 16px;
  position: relative;
  z-index: 1;
}
header .side-menu .wrapper-items-mobile .menu ul {
  padding: 16px 16px 24px;
  border-bottom: 1px solid var(--sebrae-blue-6);
  display: flex;
  gap: 24px;
  flex-direction: column;
}
header .side-menu .wrapper-items-mobile .menu ul li {
  font-size: 16px;
  color: var(--sebrae-blue-6);
  opacity: 0;
  animation: slideOpacityInLeftToRight 255ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
header .side-menu .wrapper-items-mobile .menu ul li a {
  font: inherit;
  color: inherit;
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 8px;
}
header .side-menu .wrapper-items-mobile .menu ul li span {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
header .side-menu .wrapper-items-mobile .menu ul.sub-menu li {
  font-size: 13px;
}
header .side-menu .wrapper-items-mobile .menu ul:last-of-type {
  border: none;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(1) {
  animation-delay: 0ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(1) {
  animation-delay: 505ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(2) {
  animation-delay: 50ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(2) {
  animation-delay: 555ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(3) {
  animation-delay: 100ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(3) {
  animation-delay: 605ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(4) {
  animation-delay: 150ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(4) {
  animation-delay: 655ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(5) {
  animation-delay: 200ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(5) {
  animation-delay: 705ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(6) {
  animation-delay: 250ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(6) {
  animation-delay: 755ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(7) {
  animation-delay: 300ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(7) {
  animation-delay: 805ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(8) {
  animation-delay: 350ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(8) {
  animation-delay: 855ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(9) {
  animation-delay: 400ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(9) {
  animation-delay: 905ms;
}
header .side-menu .wrapper-items-mobile .menu ul:first-of-type li:nth-child(10) {
  animation-delay: 450ms;
}
header .side-menu .wrapper-items-mobile .menu ul:nth-of-type(2) li:nth-child(10) {
  animation-delay: 955ms;
}
header .icon-profile {
  position: relative;
}
header .icon-profile .menu-profile-dropdown {
  position: absolute;
  z-index: 11;
  top: 42px;
  right: -8px;
  border-radius: 4px;
  background: var(--sebrae-light-gray);
  width: 280px;
  max-height: 293px;
  border: 1px solid rgb(207, 226, 252);
  box-shadow: rgba(20, 46, 82, 0.2) 0 8px 12px 0;
  transform-origin: top;
  transform: scaleY(0);
  opacity: 0;
  transition: transform 255ms cubic-bezier(0.4, 0, 0.2, 1), opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
header .icon-profile .menu-profile-dropdown .menu-profile {
  width: 100%;
  height: 100%;
  padding: 14px;
  opacity: 0;
  transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--sebrae-dark-gray3);
}
header .icon-profile .menu-profile-dropdown .profile {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
header .icon-profile .menu-profile-dropdown .profile h5 {
  font-size: 13px;
  margin-bottom: 3px;
  line-height: 1.2;
}
header .icon-profile .menu-profile-dropdown .profile h6 {
  font-size: 11px;
  color: var(--sebrae-light-gray2);
}
header .icon-profile .menu-profile-dropdown .profile .acronyms {
  min-width: 38px;
  width: 38px;
  height: 38px;
}
header .icon-profile .menu-profile-dropdown .profile .info {
  align-self: center;
  overflow: hidden;
  flex: 1 1;
}
header .icon-profile .menu-profile-dropdown .profile button {
  width: 16px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
header .icon-profile .menu-profile-dropdown ul {
  width: 100%;
  height: auto;
  display: flex;
  gap: 16px;
  flex-direction: column;
  color: var(--sebrae-blue-6);
  font-size: 13px;
  padding: 16px 20px 8px 50px;
}
header .icon-profile .menu-profile-dropdown ul a,
header .icon-profile .menu-profile-dropdown ul button {
  font: inherit;
  color: inherit;
  text-decoration: none;
}
header .icon-profile .menu-profile-dropdown ul a:hover,
header .icon-profile .menu-profile-dropdown ul button:hover {
  text-decoration: underline;
}
header .icon-profile .menu-profile-dropdown::before {
  content: "";
  display: block;
  transform: rotate(45deg) scale(1) translateY(0px);
  position: absolute;
  top: -7px;
  right: 17px;
  opacity: 0;
  height: 14px;
  width: 14px;
  background: var(--sebrae-light-gray);
  border-width: 1px;
  border-style: solid;
  border-image: initial;
  pointer-events: none;
  border-radius: 3px 0 0 0;
  border-color: rgb(207, 226, 252) transparent transparent rgb(207, 226, 252);
  transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
header .icon-profile .menu-profile-dropdown.opened {
  transform: scaleY(1);
  opacity: 1;
}
header .icon-profile .menu-profile-dropdown.opened .menu-profile {
  opacity: 1;
}
header .icon-profile .menu-profile-dropdown.opened::before {
  opacity: 1;
}
header .BaSe--User-Apps .BaSe--icon-button {
  padding: 0;
  font-size: 20px;
}
header .BaSe--User-Apps .BaSe--icon-button img {
  width: 24px;
  height: 24px;
}
header .BaSe--User-Apps-menu {
  right: auto;
  left: 0;
  width: 290px;
}
header .BaSe--User-Apps-menu div:first-of-type {
  left: 8px;
}
header .BaSe--User-Apps-menu div:nth-of-type(2) {
  padding-top: 12px;
}
header .BaSe--User-Apps-menu div:nth-of-type(4) {
  max-height: 280px;
  overflow-y: auto;
}
@media screen and (min-width: 375px) {
  header .BaSe--User-Apps-menu {
    width: 340px;
  }
  header .BaSe--User-Apps-menu div:nth-of-type(4) {
    max-height: inherit;
  }
}
@media screen and (min-width: 768px) {
  header .BaSe--User-Apps-menu {
    width: 440px;
  }
}
header .notifications-profile {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
@media screen and (min-width: 375px) {
  header .icon-profile .menu-profile-dropdown {
    width: 295px;
  }
  header .icon-profile .menu-profile-dropdown .menu-profile {
    padding: 16px;
  }
}
@media screen and (min-width: 1200px) {
  header {
    height: 60px;
  }
  header .hamburger,
  header .close {
    display: none;
  }
  header .header-actions {
    gap: 16px;
  }
  header .logo {
    width: 209px;
    min-width: 209px;
  }
  header .desktop {
    display: flex;
  }
  header .desktop ul li:hover {
    border-color: var(--sebrae-blue-6);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/header/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,6CAAA;AACF;AACE;EACE,YAAA;EACA,4BAAA;AACJ;AACE;;EAEE,YAAA;EACA,uBAAA;EACA,UAAA;AACJ;AACE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AACJ;AACI;EACE,SAAA;EACA,UAAA;EACA,iBAAA;AACN;AACM;EACE,yBAAA;AACR;AACM;EACE,eAAA;AACR;AAEI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAAN;AAEM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,gCAAA;AAAR;AAGI;EACE,aAAA;EACA,YAAA;AADN;AAGM;EAEI,eAAA;EACA,gBAAA;EAEF,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,kDAAA;AAHR;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AAHV;AAMQ;EACE,kCAAA;EACA,gBAAA;AAJV;AASM;EACE,eAAA;AAPR;AASQ;EACE,WAAA;EACA,YAAA;AAPV;AAWM;EACE,SAAA;EACA,UAAA;EACA,YAAA;AATR;AAWQ;EACE,UAAA;EACA,WAAA;AATV;AAcE;EACE,WAAA;EACA,sBAAA;EACA,2BAAA;AAZJ;AAaI;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;AAbN;AAeI;EACE,eAAA;AAbN;AAgBE;EACE,qBAAA;EACA,YAAA;AAdJ;AAgBE;EACE,YAAA;AAdJ;AAeI;EACE,gBAAA;AAbN;AAgBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAdJ;AAgBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAdJ;AAgBE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAdJ;AAgBI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AAdN;AAgBI;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,YAAA;EACA,+BAAA;EACA,2CAAA;AAdN;AAgBM;EACE,yEAAA;AAdR;AAiBM;EACE,0EAAA;AAfR;AAkBM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;AAhBR;AAkBQ;EACE,YAAA;AAhBV;AAkBU;EACE,WAAA;AAhBZ;AAqBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;AAnBN;AAqBM;EACE,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AAnBR;AA4BQ;EACE,uBAAA;EACA,6CAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;AA1BV;AA4BU;EACE,eAAA;EACA,2BAAA;EACA,UAAA;EACA,gFAAA;AA1BZ;AA6BY;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,QAAA;AA3Bd;AA6BY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3Bd;AAgCY;EACE,eAAA;AA9Bd;AAkCU;EACE,YAAA;AAhCZ;AAoCU;EACE,oBAAA;AAlCZ;AAoCU;EACE,sBAAA;AAlCZ;AA8BU;EACE,qBAAA;AA5BZ;AA8BU;EACE,sBAAA;AA5BZ;AAwBU;EACE,sBAAA;AAtBZ;AAwBU;EACE,sBAAA;AAtBZ;AAkBU;EACE,sBAAA;AAhBZ;AAkBU;EACE,sBAAA;AAhBZ;AAYU;EACE,sBAAA;AAVZ;AAYU;EACE,sBAAA;AAVZ;AAMU;EACE,sBAAA;AAJZ;AAMU;EACE,sBAAA;AAJZ;AAAU;EACE,sBAAA;AAEZ;AAAU;EACE,sBAAA;AAEZ;AANU;EACE,sBAAA;AAQZ;AANU;EACE,sBAAA;AAQZ;AAZU;EACE,sBAAA;AAcZ;AAZU;EACE,sBAAA;AAcZ;AAlBU;EACE,sBAAA;AAoBZ;AAlBU;EACE,sBAAA;AAoBZ;AAdE;EACE,kBAAA;AAgBJ;AAdI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,8CAAA;EACA,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,oGAAA;AAgBN;AAbM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,sDAAA;EACA,+BAAA;AAeR;AAbM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAeR;AAbQ;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAeV;AAbQ;EACE,eAAA;EACA,gCAAA;AAeV;AAbQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAeV;AAbQ;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;AAeV;AAbQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAeV;AAZM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;AAcR;AALQ;;EAEE,aAAA;EACA,cAAA;EACA,qBAAA;AAOV;AALU;;EACE,0BAAA;AAQZ;AAJM;EACE,WAAA;EACA,cAAA;EACA,iDAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,2EAAA;EAEA,sDAAA;AAKR;AAHM;EACE,oBAAA;EACA,UAAA;AAKR;AAHQ;EACE,UAAA;AAKV;AAHQ;EACE,UAAA;AAKV;AACI;EACE,UAAA;EACA,eAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;AACR;AAEI;EACE,WAAA;EACA,OAAA;EACA,YAAA;AAAN;AAGQ;EACE,SAAA;AADV;AAGQ;EACE,iBAAA;AADV;AAGQ;EACE,iBAAA;EACA,gBAAA;AADV;AAKM;EAlBF;IAmBI,YAAA;EAFN;EAKQ;IACE,mBAAA;EAHV;AACF;AAMM;EA3BF;IA4BI,YAAA;EAHN;AACF;AAME;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAJJ;AAOE;EAEI;IACE,YAAA;EANN;EAQM;IACE,aAAA;EANR;AACF;AAYE;EArcF;IAscI,YAAA;EATF;EAWE;;IAEE,aAAA;EATJ;EAWE;IACE,SAAA;EATJ;EAWE;IACE,YAAA;IACA,gBAAA;EATJ;EAWE;IACE,aAAA;EATJ;EAYM;IACE,kCAAA;EAVR;AACF","sourcesContent":["header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 56px;\n  z-index: 11;\n  background: var(--sebrae-light-gray);\n  box-shadow: 0 8px 8px 0 rgba(20, 46, 82, 0.2);\n\n  .container {\n    height: 100%;\n    max-width: 1376px !important;\n  }\n  .hamburger,\n  .close {\n    border: none;\n    background: transparent;\n    padding: 0;\n  }\n  .desktop {\n    display: none;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 16px;\n\n    .company {\n      flex: 1;\n      padding: 0;\n      padding-left: 8px;\n\n      h3 {\n        text-transform: uppercase;\n      }\n      button {\n        font-size: 12px;\n      }\n    }\n    nav {\n      position: relative;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding-right: 12px;\n\n      &:after {\n        content: \"\";\n        position: absolute;\n        right: 0;\n        width: 1px;\n        height: 24px;\n        background: var(--sebrae-blue-6);\n      }\n    }\n    ul {\n      display: flex;\n      height: 100%;\n\n      li {\n        font: {\n          size: 13px;\n          weight: 400;\n        }\n        color: var(--sebrae-blue-6);\n        padding: 5px 8px 0;\n        height: 100%;\n        border-bottom: 6px solid transparent;\n        transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n        a {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          height: 100%;\n          font: inherit;\n          color: inherit;\n          text-decoration: none;\n        }\n\n        &.active {\n          border-color: var(--sebrae-blue-6);\n          font-weight: 700;\n        }\n      }\n    }\n    .BaSe--User-Apps {\n      .BaSe--icon-button {\n        font-size: 16px;\n\n        img {\n          width: 16px;\n          height: 16px;\n        }\n      }\n\n      &-menu {\n        top: 25px;\n        left: auto;\n        right: -20px;\n\n        div:first-of-type {\n          left: auto;\n          right: 22px;\n        }\n      }\n    }\n  }\n  .company {\n    width: 100%;\n    padding: 15px 16px 8px;\n    color: var(--sebrae-blue-6);\n    h3 {\n      font: {\n        size: 13px;\n        weight: 700;\n      }\n      line-height: 1.2;\n    }\n    button {\n      font-size: 11px;\n    }\n  }\n  .logo {\n    display: inline-block;\n    width: 125px;\n  }\n  .btn-white-outline {\n    border: none;\n    span {\n      font-weight: 400;\n    }\n  }\n  .acronyms {\n    min-width: 32px;\n    width: 32px;\n    height: 32px;\n  }\n  .header-actions {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .side-menu {\n    position: fixed;\n    width: 100%;\n    height: 100dvh;\n    top: 0;\n    left: 0;\n    z-index: 10;\n\n    .overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      cursor: pointer;\n      background: rgba(0, 0, 0, 0.3);\n      z-index: -1;\n    }\n    nav {\n      position: relative;\n      z-index: 1;\n      width: calc(100% - 56px);\n      height: 100%;\n      background: var(--sebrae-white);\n      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);\n\n      &.slide-in {\n        animation: slideInLeftToRight 255ms cubic-bezier(0.4, 0, 0.2, 1)\n        forwards;\n      }\n      &.slide-out {\n        animation: slideOutRightToLeft 255ms cubic-bezier(0.4, 0, 0.2, 1)\n        forwards;\n      }\n      .nav-actions {\n        width: 100%;\n        height: 56px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 10px;\n        padding: 5px 16px;\n\n        .logo {\n          width: 209px;\n\n          img {\n            width: 100%;\n          }\n        }\n      }\n    }\n    .wrapper-items-mobile {\n      width: 100%;\n      height: 100%;\n      display: grid;\n      grid-template-columns: 56px 1fr;\n\n      .aside-icon {\n        background: var(--sebrae-blue-6);\n        padding: 16px;\n        position: relative;\n        z-index: 1;\n      }\n      .menu {\n        $animation-duration: 255ms;\n        $delay-step: 50ms;\n        $first-ul-items: 6;\n        $first-ul-total: $animation-duration + $delay-step *\n          ($first-ul-items - 1);\n\n        ul {\n          padding: 16px 16px 24px;\n          border-bottom: 1px solid var(--sebrae-blue-6);\n          display: flex;\n          gap: 24px;\n          flex-direction: column;\n\n          li {\n            font-size: 16px;\n            color: var(--sebrae-blue-6);\n            opacity: 0;\n            animation: slideOpacityInLeftToRight $animation-duration\n            cubic-bezier(0.4, 0, 0.2, 1) forwards;\n\n            a {\n              font: inherit;\n              color: inherit;\n              display: flex;\n              align-items: center;\n              text-decoration: none;\n              gap: 8px;\n            }\n            span {\n              width: 16px;\n              height: 16px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n            }\n          }\n\n          &.sub-menu {\n            li {\n              font-size: 13px;\n            }\n          }\n\n          &:last-of-type {\n            border: none;\n          }\n        }\n        @for $i from 1 through 10 {\n          ul:first-of-type li:nth-child(#{$i}) {\n            animation-delay: ($i - 1) * $delay-step;\n          }\n          ul:nth-of-type(2) li:nth-child(#{$i}) {\n            animation-delay: $first-ul-total + ($i - 1) * $delay-step;\n          }\n        }\n      }\n    }\n  }\n  .icon-profile {\n    position: relative;\n\n    .menu-profile-dropdown {\n      position: absolute;\n      z-index: 11;\n      top: 42px;\n      right: -8px;\n      border-radius: 4px;\n      background: var(--sebrae-light-gray);\n      width: 280px;\n      max-height: 293px;\n      border: 1px solid rgb(207, 226, 252);\n      box-shadow: rgba(20, 46, 82, 0.2) 0 8px 12px 0;\n      transform-origin: top;\n      transform: scaleY(0);\n      opacity: 0;\n      transition: transform 255ms cubic-bezier(0.4, 0, 0.2, 1),\n      opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n      .menu-profile {\n        width: 100%;\n        height: 100%;\n        padding: 14px;\n        opacity: 0;\n        transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);\n        color: var(--sebrae-dark-gray3);\n      }\n      .profile {\n        display: flex;\n        align-items: flex-start;\n        gap: 12px;\n\n        h5 {\n          font-size: 13px;\n          margin-bottom: 3px;\n          line-height: 1.2;\n        }\n        h6 {\n          font-size: 11px;\n          color: var(--sebrae-light-gray2);\n        }\n        .acronyms {\n          min-width: 38px;\n          width: 38px;\n          height: 38px;\n        }\n        .info {\n          align-self: center;\n          overflow: hidden;\n          flex: 1;\n        }\n        button {\n          width: 16px;\n          min-width: 16px;\n          height: 16px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n      ul {\n        width: 100%;\n        height: auto;\n        display: flex;\n        gap: 16px;\n        flex-direction: column;\n        color: var(--sebrae-blue-6);\n        font-size: 13px;\n        padding: 16px 20px 8px 50px;\n\n        //li {\n        //  &:first-of-type {\n        //    padding-bottom: 16px;\n        //    border-bottom: 1px solid var(--sebrae-light-gray4);\n        //  }\n        //}\n\n        a,\n        button {\n          font: inherit;\n          color: inherit;\n          text-decoration: none;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n      &::before {\n        content: \"\";\n        display: block;\n        transform: rotate(45deg) scale(1) translateY(0px);\n        position: absolute;\n        top: -7px;\n        right: 17px;\n        opacity: 0;\n        height: 14px;\n        width: 14px;\n        background: var(--sebrae-light-gray);\n        border-width: 1px;\n        border-style: solid;\n        border-image: initial;\n        pointer-events: none;\n        border-radius: 3px 0 0 0;\n        border-color: rgb(207, 226, 252) transparent transparent\n        rgb(207, 226, 252);\n        transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);\n      }\n      &.opened {\n        transform: scaleY(1);\n        opacity: 1;\n\n        .menu-profile {\n          opacity: 1;\n        }\n        &::before {\n          opacity: 1;\n        }\n      }\n    }\n  }\n  .BaSe--User-Apps {\n    .BaSe--icon-button {\n      padding: 0;\n      font-size: 20px;\n\n      img {\n        width: 24px;\n        height: 24px;\n      }\n    }\n    &-menu {\n      right: auto;\n      left: 0;\n      width: 290px;\n\n      div {\n        &:first-of-type {\n          left: 8px;\n        }\n        &:nth-of-type(2) {\n          padding-top: 12px;\n        }\n        &:nth-of-type(4) {\n          max-height: 280px;\n          overflow-y: auto;\n        }\n      }\n\n      @media screen and (min-width: 375px) {\n        width: 340px;\n\n        div {\n          &:nth-of-type(4) {\n            max-height: inherit;\n          }\n        }\n      }\n      @media screen and (min-width: 768px) {\n        width: 440px;\n      }\n    }\n  }\n  .notifications-profile {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n  }\n\n  @media screen and (min-width: 375px) {\n    .icon-profile {\n      .menu-profile-dropdown {\n        width: 295px;\n\n        .menu-profile {\n          padding: 16px;\n        }\n        &.opened {\n        }\n      }\n    }\n  }\n  @media screen and (min-width: 1200px) {\n    height: 60px;\n\n    .hamburger,\n    .close {\n      display: none;\n    }\n    .header-actions {\n      gap: 16px;\n    }\n    .logo {\n      width: 209px;\n      min-width: 209px;\n    }\n    .desktop {\n      display: flex;\n\n      ul li {\n        &:hover {\n          border-color: var(--sebrae-blue-6);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
